module.exports = __webpack_public_path__ + "static/three-women-phone-2fe10d303cebbe6b1dc42ce9eee35845.png";